import type { IconProps } from './types';

export const ChevronDownIcon: React.FC<IconProps> = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth={1.5} {...props}>
            <path d="M7.0498 10.499L11.9996 15.1914L16.9493 10.499" stroke="currentColor" />
        </svg>
    );
};
